module.exports = __webpack_public_path__ + "assets/img/ef84df86a0f834821179bd1f9d55c574.svg";